import ApiClient from "./apiCient.js";
import axios from "axios";
const base_URL = process.env.REACT_APP_API_BASE_URL;
class UserApi extends ApiClient {
  constructor() {
    super(base_URL);

  }



  signUpUsers(data) {
    return this.post("/user/save-signup-details", data);
  }

  sendSignInLink(data) {
    return this.post("/auth/login-via-otp", data);
  }

  getUserDetails() {
    return this.get(`/user/get-user-details`);
  }

  getAllEvents() {
    return this.get("/user/upcoming-events");
  }

  getAllFeeds() {
    return this.get("/user/feeds");
  }

  createUser(data) {
    return this.post("/users", data);
  }

  updateUser(data) {
    return this.post(`/user/update-user-details`, data);
  }

  deleteUser(id) {
    return this.delete(`/users/${id}`);
  }

  getAllUsers() {
    return this.get("/user");
  }

  createGatePass(data) {
    // Ensure all required fields are present
    const requiredFields = [
      'date',
      'time',
      'duration',
      'numberOfGuests',
      'purpose',
      'vehicleNumber',
      'vehicleType'
    ];

    // Check for missing required fields
    const missingFields = requiredFields.filter(field => !data[field]);
    if (missingFields.length > 0) {
      throw new Error(`Missing required fields: ${missingFields.join(', ')}`);
    }

    // Validate data types
    if (typeof data.date !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(data.date)) {
      throw new Error('Invalid date format. Expected YYYY-MM-DD');
    }

    if (typeof data.time !== 'string' || !/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/.test(data.time)) {
      throw new Error('Invalid time format. Expected HH:mm');
    }

    if (typeof data.duration !== 'number' || data.duration < 1 || data.duration > 24) {
      throw new Error('Duration must be a number between 1 and 24');
    }

    if (typeof data.numberOfGuests !== 'number' || data.numberOfGuests < 1) {
      throw new Error('Number of guests must be at least 1');
    }

    if (typeof data.purpose !== 'string') {
      throw new Error('Purpose must be a string');
    }

    if (typeof data.vehicleNumber !== 'string') {
      throw new Error('Vehicle number must be a string');
    }

    if (typeof data.vehicleType !== 'string') {
      throw new Error('Vehicle type must be a string');
    }

    // Format the data for the API
    const formattedData = {
      date: data.date,
      time: data.time,
      duration: data.duration,
      numberOfGuests: data.numberOfGuests,
      purpose: data.purpose,
      vehicleNumber: data.vehicleNumber.trim().toUpperCase(),
      vehicleType: data.vehicleType
    };

    console.log('Submitting gate pass data:', formattedData); // Debug log

    return this.post('/user/generate-gate-pass', formattedData);
  }

  getAllGatePasses() {
    return this.get("/user/gate-passes");
  }

  async getPostById(id) {
    return this.get(`/user/post/${id}`);
  }
}

export default new UserApi();
